import React, { FC, useEffect, useState } from 'react';
import { message, Skeleton } from 'antd';
import Axios from 'axios';
import SectionCard from './SectionCard';
import Container from 'app/layouts/layout/Container';
import { getSections, SectionI } from 'app/adapters/Sections';
import './SectionsListing.scss';

const SectionsListing: FC = () => {
  const [sections, setSections] = useState<SectionI[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getSectionsData = async () => {
    try {
      const { data } = await getSections().finally(() => {
        setIsLoading(false);
      });
      setSections(data.results);
    } catch (error) {
      if (!Axios.isCancel(error)) {
        message.error('An error occurred while fetching the sections data');
      }
    }
  };

  useEffect(() => {
    getSectionsData();
  }, []);
  return (
    <Container
      className={'article-listing-wrapper'}
      bgColor="gray"
      maxWidth="XXL"
    >
      <div className="article-listing">
        {!isLoading ? (
          sections?.map(section => (
            <SectionCard key={section.title} {...section} />
          ))
        ) : (
          <Skeleton
            active
            paragraph={false}
            title={{
              style: { height: '538px', width: '100%' },
            }}
          />
        )}
      </div>
    </Container>
  );
};

export default SectionsListing;
